import { render, staticRenderFns } from "./CreateParentCompany.vue?vue&type=template&id=60d17e68&scoped=true&"
import script from "./CreateParentCompany.vue?vue&type=script&lang=js&"
export * from "./CreateParentCompany.vue?vue&type=script&lang=js&"
import style0 from "./CreateParentCompany.vue?vue&type=style&index=0&id=60d17e68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d17e68",
  null
  
)

export default component.exports